export default "__VITE_ASSET__b3_f5n6H__"